module.exports = __webpack_public_path__ + "img/pic.e9460787.png";